import React, { ComponentType, useState } from 'react';

interface DrawerProperties {
  open: boolean;
  onOpenDrawer: () => void;
  onCloseDrawer: () => void;
}

const withDrawerState = <P extends object>(
  ComponentWithDrawer: ComponentType<DrawerProperties & P>) => {
  const WithDrawerState = (properties: P) => {
    const [open, setOpen] = useState(false);

    const onOpenDrawer = () => setOpen(
      (previousOpenState) => !previousOpenState,
    );

    const onCloseDrawer = () => setOpen(false);

    return (
      <ComponentWithDrawer
        open={open}
        onOpenDrawer={onOpenDrawer}
        onCloseDrawer={onCloseDrawer}
        {...properties}
      />
    );
  };

  return WithDrawerState;
};

export default withDrawerState;
